import type { PiniaPluginContext } from 'pinia'
import { cloneDeep as _cloneDeep } from 'lodash-es'

/**
 * 由於用 function/setup 寫法定義的 Pinia Store 無法使用 $reset
 * Store "xxx" is build using the setup syntax and does not implement $reset().
 * 因此自定 pinia plugin 添加 $reset 功能
 */
function resetStore({ store }: PiniaPluginContext) {
  const initialState = _cloneDeep(store.$state)
  store.$reset = () => store.$patch(_cloneDeep(initialState))
}

export default defineNuxtPlugin(nuxtApp => {
  if (nuxtApp._piniaPlugin) return
  ;(nuxtApp.$pinia as any).use(resetStore)
  nuxtApp._piniaPlugin = true
})
